import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User, } from '../_models/user';
import { ResponseUser } from '../_models/response-user.enum';
import { DefaultUrlSerializer, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { GatewayService } from './getway.service';
import { UserService } from './user.service';
import { RespuestaLogin } from '../_models/respuestaLogin';
import { ProductoService } from './producto.service';
import { MessageService } from './message.service';
import { LogingService } from './loging.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  public producto: Number;


  constructor(private http: GatewayService,
    private router: Router,
    private userService: UserService,
    private productoService: ProductoService,
    private logingService: LogingService,
    private messageService: MessageService) {

  }

  signUpExterno(identificadorUsuario: string): Observable<any> {
    this.userService.updateUser({
      accessToken: localStorage.getItem(identificadorUsuario + '.accessToken'),
      tokenPermisos: null,
      refreshToken: localStorage.getItem(identificadorUsuario + '.refreshToken'),
      idToken: localStorage.getItem(identificadorUsuario + '.idToken'),
    });
    let params = {};
    return this.http.post<any>(environment.urlApi + 'api/v1/usuario/RegistrarUsuarioExterno', params, true);
  }

  validarRespuestaUsuario(codigoRespuesta: string, session: string, username: string, password: string,
    idAplicacion: string, redirectUrl: string, filtroAdicional: string): Boolean {
    const encripted = CryptoJS.AES.encrypt(username + '|' + password, environment.encodeKey).toString().split('/').join();
    switch (codigoRespuesta) {
      case ResponseUser.UNCONFIRMED:
        this.router.navigate(['/verification/', idAplicacion, encripted], {
          queryParams: {
            redirectUrl,
            filtroAdicional
          }
        });
        return false;
      case ResponseUser.CHANGEPASSWORD:
        this.router.navigate(['/resetpassword', idAplicacion, encripted, session], {
          queryParams: {
            redirectUrl,
            filtroAdicional
          }
        });
        return false;
      case ResponseUser.USERFEDERATEACCOUNT:
        this.messageService.sendMessage("Información", "Tu registro fue con cuenta Google, inicia sesión a través de ese medio.", null, "info");
        return false;
      default:
        return true;
    }
  }

  isUserLogedIn(): boolean {
    return this.userService.isLogedIn();
  }

  cambioProducto(idAplicacion: string, filtroAdicional: string, redirectUrl?: string): Observable<RespuestaLogin> {
        
    redirectUrl == undefined ? '' : redirectUrl;
    const params = {
      filtroAdicional: filtroAdicional,
      idAplicacion: idAplicacion,
      redirectUrl: redirectUrl
    };

    return this.http.get<RespuestaLogin>(environment.urlApi + 'api/v1/autenticacion/AutenticarNuevoProducto', params, true)
      .pipe(map(resultado => {
        let response = new RespuestaLogin();
        response = resultado;
        this.userService.updateTokenPermisos(idAplicacion, response.tokenPermisos);
        return response;
      }));
  }

  login(username: string, password: string, idAplicacion: string, filtroAdicional: string): Observable<RespuestaLogin> {
    const params = {
      email: username,
      password: password,
      filtroAdicional: filtroAdicional,
      idAplicacion: idAplicacion,
    };
    this.logingService.addUserEmail(username);
    return this.http.get<any>(environment.urlApi + 'api/v1/autenticacion/login', params, false)
      .pipe(map(result => {
        this.updateUser(result, idAplicacion);
        return result;
      }));
  }



  private updateUser(result: any, idAplicacion: string) {
    const user: User = {
      idToken: result.idToken,
      accessToken: result.accessToken,
      refreshToken: result.refreshToken,
      tokenPermisos: {
        idProducto: idAplicacion,
        tokenPermisos: result.tokenPermisos
      }
    };
    this.userService.updateUser(user);
  }

  sendPasswordRecover(email: string): Observable<any> {
    const data = {
      Email: email,
    };
    this.logingService.addUserEmail(email);
    return this.http.post<any>(environment.urlApi + 'api/v1/autenticacion/RecuperarPassword', data, false);
  }

  changePassword(username: string, codigo: string, newPassword: string): Observable<boolean> {
    const data = {
      Email: username,
      Codigo: codigo,
      Password: newPassword
    };
    return this.http.post<any>(environment.urlApi + 'api/v1/autenticacion/ConfirmarSolicitudRecuperarPassword', data, false);
  }

  modifyPassword(password: string, newPassword: string, passwordConfirm: string): Observable<boolean> {
    const data = {
      Password: password,
      NewPassword: newPassword,
      NewPasswordConfirm: passwordConfirm
    };
    return this.http.post<any>(environment.urlApi + 'api/v1/autenticacion/CambiarPassword', data, true);
  }

  signUp(nombre: string, apellido: string, email: string, password: string): Observable<boolean> {

    const data = {
      Nombre: nombre,
      Apellido: apellido,
      Email: email,
      Password: password
    };

    return this.http.post<any>(environment.urlApi + 'api/v1/usuario/registrar', data, false);
  }

  confirmSignUp(userName: string, codigo: string): Observable<boolean> {

    const data = {
      NombreUsuario: userName,
      Codigo: codigo,
    };

    return this.http.post<any>(environment.urlApi + 'api/v1/usuario/confirmarcuenta', data, false);
  }

  resendCode(username: string): Observable<boolean> {
    const data = {
      IdentificadorUsuario: username,
    };
    return this.http.post<any>(environment.urlApi + 'api/v1/autenticacion/ReenviarCodigoConfirmacion', data, false);
  }

  logoutUser() {
    return this.http.get<any>(environment.urlApi + 'api/v1/Autenticacion/ObtenerConfiguracionProductos', null, true).pipe(map(result => {
      this.http.get<any>(environment.urlApi + 'api/v1/Autenticacion/CerrrarSession', {
        token: this.userService.getRefreshToken()
      }, false).subscribe();
      this.userService.logout();
      return result;
    }
    ));
  }

  loginExterno(identificadorUsuario: string, idAplicacion: string, filtroAdicional: string): Observable<RespuestaLogin> {
    const usuario: User = {
      idToken: localStorage.getItem(identificadorUsuario + '.idToken'),
      refreshToken: localStorage.getItem(identificadorUsuario + '.refreshToken'),
      accessToken: localStorage.getItem(identificadorUsuario + '.accessToken'),
      tokenPermisos: null
    };
    this.userService.updateUser(usuario);
    return this.cambioProducto(idAplicacion, filtroAdicional);
  }

  resetPassword(email: string, newPassword: string, session: string, idAplicacion: string): Observable<RespuestaLogin> {
    const data = {
      email: email,
      newPassword: newPassword,
      session: session,
      idAplicacion: idAplicacion
    };
    return this.http.get<RespuestaLogin>(environment.urlApi + 'api/v1/autenticacion/CambioPasswordChallenge', data, false)
      .pipe(map(result => {
        this.updateUser(result, idAplicacion);
        return result;
      }));
  }

  redirectUsuarioLogeado(data: RespuestaLogin, redirectUrl: string) {
    this.productoService.clearLoginParams();
    this.userService.getAccessToken().subscribe(token => {
      
      if (redirectUrl) {
        window.open(data.returnUrl + redirectUrl, '_self');          
      } else {
        window.open(data.returnUrl, '_self');
      }        
    });
  }
}
